/**
 * Accès localStorage tolérant : navigation privée, quota dépassé ou stockage
 * désactivé ne doivent jamais casser la visite (cf. §24).
 */

let memoryFallback: Record<string, string> = {};

function backend(): Storage | null {
  try {
    const probe = '__ch_probe__';
    window.localStorage.setItem(probe, '1');
    window.localStorage.removeItem(probe);
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readJson<T>(key: string): T | null {
  const store = backend();
  const raw = store ? store.getItem(key) : (memoryFallback[key] ?? null);
  if (raw === null) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function writeJson(key: string, value: unknown): boolean {
  const raw = JSON.stringify(value);
  const store = backend();
  if (!store) {
    memoryFallback[key] = raw;
    return false;
  }
  try {
    store.setItem(key, raw);
    return true;
  } catch {
    memoryFallback[key] = raw;
    return false;
  }
}

export function removeKey(key: string): void {
  const store = backend();
  if (store) {
    try {
      store.removeItem(key);
    } catch {
      /* ignoré : le repli mémoire suffit */
    }
  }
  delete memoryFallback[key];
}

/** Réinitialise le repli mémoire — utilisé par les tests. */
export function resetMemoryFallback(): void {
  memoryFallback = {};
}
